import { Application } from "@hotwired/stimulus"

const application = Application.start()


// redefine router.scopeConnected, warn when a controller is not defined
const router = application.router
const original = router.scopeConnected.bind(router)

const warned = new Map();

router.scopeConnected = function (scope) {
  original(scope)

  // If no module registered for this identifier, it's "missing"
  if (!this.modulesByIdentifier.get(scope.identifier)) {
    let set = warned.get(`${scope.identifier}`)
    if (!set) warned.set(`${scope.identifier}`, true)
    if (set) return

    console.error(`[Stimulus] Missing controller "${scope.identifier}"`, scope.element)
  }
}

// end

// Configure Stimulus development experience
application.debug = false

window.Stimulus   = application

export { application }
